import {FC, useEffect, useMemo, useState} from 'react'

import 'bootstrap-icons/font/bootstrap-icons.css'
import './Wizardstep.scss'

import moment from 'moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {ulid} from 'ulid'
import {KTSVG, countWords, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {useGetAllTagsQuery, useLazyGetGroupQuery} from '../../../../../services/cellcast'
import AlertMessageBox from '../../../../Components/AlertMessageBox'
import ContectListsPopup from '../../../../Components/ContectListsPopup'
import ContectSegmentListsPopup from '../../../../Components/ContectSegmentListsPopup'
import {FirstTimeApprovalData} from '../../../../Components/PopupSlice/popupSlice'
import PurchasePopup from '../../../../Components/PurchasePopup'
import SuccessPopup from '../../../../Components/SuccessPopup'
import {useTimezone} from '../../../../hooks/useTimezone'
import {stopLoadingSend} from '../../../../Redux/FrontEnd/Loading/LoadingSendSlice'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncQuickMms} from '../../../../Redux/FrontEnd/QuickMessageSlice/quickMmsSlice'
import {fetchAsyncQuickSms} from '../../../../Redux/FrontEnd/QuickMessageSlice/QuickSmsSlice'
import {base64ToFile, fileToBase64, replaceMessageWith} from '../../../../Utils/_helpers'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {GeneralDataOFLoginUser} from '../../../../Utils/Auth'
import {GLOBAL_SETTINGS_TYPE, REGION} from '../../../../Utils/Constant/ConstantForWebsite'
import {fetchAsyncUserDetails, getDefaultOptOutUrl} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {GetAllData} from '../../Contacts/Segments/SegmentSlice/SegmentSlice'
import {storeReportId} from '../../reports-analytics/reportSlices/reportAnalytics'
import {
  BulkMessageReview,
  BulkMsgDraftData,
  GetPrevioslySentCampaigsList,
  GetSavedCampaigsList,
  SaveCampaigsData,
  UpdateSaveCampaigsData,
  getReviewData,
  sendBulkMessageData,
  sendBulkMessagemmsData,
  totalCounts,
  totalRecipients,
} from '../BulkMessageSlice/BulkMessageSlice'
import Bulk_Message_MesssageBox from './Bulk_Message_Message/Bulk_Message_MesssageBox'
import Bulk_Message_Send_From from './Bulk_Message_Send_From/Bulk_Message_Send_From'
import BulkMessageSendTo from './Bulk_Message_Send_To/BulkMessageSendTo'
import Bulk_Message_when from './Bulk_Message_When/Bulk_Message_when'
import GettingStarted from './GettingStarted/GettingStarted'
import ReviewBulkMessageData from './ReviewBulkMessageData'
import {isBase64Image} from '../../../../Utils/AllHelperFunctions'
import VCardPreview from '../../../../Components/VCardPreview'
import {useNewMessage} from '../useNewMessage'
import {useFetchTagQuery} from '../../../../../services/cellcast.v3'
import { optoutContact } from '../../Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'

export const bulkMessageState = {
  name: '',
  campaign_type: 'promotional',
  previouslySendId: {value: '', label: 'Select'},
  saveCampaignId: '',
  camp_type: 'sms',
  media: '',
  gif: '',
  message: '',
  messageSecond: '',
  subject: '',
  abTest: false,
  optout: false,
  optoutSecond: false,
  replyStopToOptOut: true,
  replyStopToOptOutSecond: true,
  to: {
    selectedType: '',
    value: '',
    exclude: false,
    excludeTags: '',
  },
  longUrl: [],
  longUrlSecond: [],
  when: '',
  whenSecond: '',
  sender: {value: '', label: ''},
  selectedTemplate: {value: '', label: 'Select Template'},
  interval: '',
  quantity: '',
  staggerMessages: false,
  landingPageId: '',
  landingPageIdSecond: '',
  senderType: '',
  filetype: '',
  url: '',
  mediaType: '',
  fileName: '',
  scheduledAt: new Date(),
  scheduledAtSecond: new Date(),
  forwardReplyTo: '',
}
const NewMessageStepper: FC = () => {
  const ReviewData = useSelector(getReviewData)
  const isAdmin = localStorage.getItem('isAdmin')
  const param: any = useLocation()
  const API_URL = ENV().REACT_APP_API_URL
  const dispatch = useDispatch()
  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)

  const optOutBaseUrl = useSelector(getDefaultOptOutUrl)

  ///////////////////////////////////USE STATE////////////////////
  const [testNumber, setTestNumber] = useState()
  const [showAlert, setShowAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')
  const [error, setError] = useState<any>({})
  const [review, setReview] = useState(false)
  const [sendFlag, setSendFlag] = useState(false)
  const [bulkMessageData, setBulkMessageData] = useState<any>(bulkMessageState)

  const [successPopupModal, setSuccessPopupModal] = useState<any>(false)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const [purchasePopupModal, setPurchasePopupModal] = useState<any>(false)
  const [contectListModel, setContectListModel] = useState<any>(false)
  const [firstTimeSend, setFirstTimeSend] = useState<any>(false)
  const [contectSegmentListModel, setSegmentContectListModel] = useState<any>(false)
  const [mmsError, setMMSError] = useState<any>(false)
  const [purchaseModelData, setPurchaseModelData] = useState({
    type: '',
    purchaseCredit: 0,
    minimum: 0,
  })
  const [checkStep, setCheckStep] = useState({
    gettingStarted: true,
    to: false,
    from: false,
    message: false,
    when: false,
  })
  const [sendError, setSendError] = useState('')
  const [segmentAndTags, setSegmentAndTags] = useState<any>([])
  const [bulkULID, setBulkULID] = useState('')
  const {toLocalTimezone} = useTimezone()
  const [isForwardIncomingMessage, setIsForwardIncomingMessage] = useState(false)
  const {isDefaultRegion, sendCalculateSummary, sendFinalMessage, currentRegion} = useNewMessage()

  /////////////////////////////USE SELECTOR//////////////////////
  const {isLoading: loadingTags, data: tagList} = useGetAllTagsQuery({})
  const {tagRegion} = useFetchTagQuery(
    {type: 'tag', limit: 1000},
    {
      selectFromResult: ({data}) => {
        return {
          tagRegion: data
            ? data?.data?.items
                ?.filter((val: any) => val.type !== 'list' && val?.isHidden === false)
                .map((val: any) => ({value: `tag_${val?._id}`, label: val?.name, group: 'tag'}))
            : [],
        }
      },
      skip: isDefaultRegion,
    }
  )

  const Segmentlist: any = useSelector((state: any) => state?.SegmentData?.segmaent?.data?.items)
  const draftData = useSelector((state: any) => state?.bulkMessageData?.BulkMsgDraftData)

  const globalSettings = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )
  const [getGroup, {data: groupData}] = useLazyGetGroupQuery()

  useEffect(() => {
    let data = param?.state?.data

    if (data && data.optout && data.optout === true) {
      data.message = data.message.replace(`\nSTOP: ${optOutBaseUrl}/vc`, '')
    }

    if (data && data.optoutSecond && data.optoutSecond === true) {
      data.messageSecond = data?.messageSecond.replace(`\nSTOP: ${optOutBaseUrl}/vc`, '')
    }

    if (data && data.replyStopToOptOut && data.replyStopToOptOut === true) {
      data.message = data.message.replace("\nReply 'STOP' to opt-out", '')
    }

    if (data && data.replyStopToOptOutSecond && data.replyStopToOptOutSecond === true) {
      data.messageSecond = data?.messageSecond.replace("\nReply 'STOP' to opt-out", '')
    }

    if (data && data.forwardReplyTo && data.forwardReplyTo !== ""){
      setIsForwardIncomingMessage(true)
    }

    param?.state?.selectedType === 'draft' &&
      setBulkMessageData({
        ...bulkMessageData,
        ...data,
        saveCampaignId: param?.state?.data?.saveCampaignId,
      })
    if (param?.state !== '' && param?.state?.selectedType !== 'draft') {
      param?.state === 'all' &&
        setBulkMessageData({
          ...bulkMessageData,
          to: {
            selectedType: 'all',
            value: 'all',
          },
        })

      param?.state?.selectedType === 'segmentOrTags' &&
        setBulkMessageData({
          ...bulkMessageData,
          to: {
            selectedType: param?.state?.selectedType,
            value: [param?.state?.data],
          },
        })

      param?.state?.selectedType === 'contacts' &&
        setBulkMessageData({
          ...bulkMessageData,
          contacts: param?.state?.data,
          to: {
            selectedType: param?.state?.selectedType,
            value: '',
          },
        })

      if (!param?.state?.selectedType) {
        setBulkMessageData(draftData ?? bulkMessageState)
      }

      window.history.replaceState({}, document.title)
    }
  }, [])

  useEffect(() => {
    dispatch(totalRecipients({to: bulkMessageData?.to}))
  }, [bulkMessageData?.to?.value, bulkMessageData?.to?.exclude, bulkMessageData?.to?.excludeTags])

  useEffect(() => {
    dispatch(
      totalCounts({
        to: {
          selectedType: 'all',
          value: 'all',
        },
      })
    )

    getGroup(null)
  }, [])

  useEffect(() => {
    let segmentOption =
      Segmentlist?.map((key: any) => {
        return {
          value: `segment_${key?._id}`,
          label: `${key?.name}`,
          group: 'segment',
        }
      }) || []

    const normalTags = tagList?.data?.filter(
      (key: any) => !key?.type || (key.type && key.type !== 'list')
    )
    const listTags = tagList?.data?.filter((key: any) => key.type && key.type === 'list')

    let tagsOption =
      normalTags?.map((key: any) => {
        return {
          value: `tag_${key?._id}`,
          label: `${key?.name}`,
          group: 'tag',
        }
      }) || []

    let listOption =
      listTags?.map((key: any) => {
        return {
          value: `tag_${key?._id}`,
          label: `${key?.name}`,
          group: 'list',
        }
      }) || []

    {isDefaultRegion 
      ? 
      setSegmentAndTags([
        {
          label: 'List',
          options: listOption,
        },
        {
          label: 'Segment',
          options: segmentOption,
        },
        {
          label: 'Tags',
          options: tagsOption,
        },
      ])
      :
      setSegmentAndTags([
        {
          label: 'Tags',
          options: tagRegion,
        },
      ])
    }
    }, [Segmentlist, tagList])
    
  ////Featch all getting started data
  useEffect(() => {
    dispatch(GetPrevioslySentCampaigsList())
    dispatch(GetSavedCampaigsList())
    dispatch(fetchAsyncUserDetails())
  }, [])
  useEffect(() => {
    dispatch(
      GetAllData({
        page: 1,
        size: 10,
        search: '',
      })
    )
  }, [Segmentlist?.total])

  ////////////////////////////////////////Save Campaign data ////////////////////////////////////
  const handleSaveData = () => {
    if (bulkMessageData.name === '') {
      setAlertMessage('Please provide campaign name')
      setShowAlert(true)
    } else {
      let finalData = {
        ...bulkMessageData,
        to: JSON.stringify(bulkMessageData.to),
        longUrl: JSON.stringify(bulkMessageData?.longUrl),
      }

      let mediaData = finalData?.media ?? ''
      if (typeof mediaData == 'string') {
        if (mediaData?.startsWith('data:')) {
          mediaData = base64ToFile(mediaData)
        }
      }

      let formData = new FormData()
      let values: any = {
        camp_type: finalData?.camp_type,
        to: finalData?.to,
        message: finalData?.message,
        name: finalData?.name,
        optout: finalData.optout ? finalData.optout : false,
        landingPage: finalData.landingPage ? finalData.landingPage : false,
        sender: finalData?.sender?.value,
        gif: finalData?.gif ? finalData?.gif : '',
        media: mediaData ? mediaData : '',
        senderType: finalData?.senderType,
        longUrl: finalData?.longUrl,
        subject: finalData?.subject,
      }

      if (finalData && finalData.landingPageId && finalData.landingPageId.length > 0) {
        values.landingPage = true
        values.landingPageId = finalData.landingPageId
      }

      if (finalData?.optout) {
        values.optoutId = finalData?.optoutId
      }

      if (finalData?.replyStopToOptOut) {
        values.replyStopToOptOut = finalData?.replyStopToOptOut
      }

      for (var key in values) {
        formData.append(key, values[key])
      }

      if (bulkMessageData?.saveCampaignId !== '' && bulkMessageData?.saveCampaignId !== undefined) {
        dispatch(
          UpdateSaveCampaigsData({id: bulkMessageData.saveCampaignId?.value, data: formData})
        )
      } else {
        dispatch(SaveCampaigsData(formData))
      }
    }
  }

  /////////////////////////////////////Review Campaign data//////////////////
  const handelSendData = async () => {
    // validation(bulkMessageData)

    const tempBulkULID = ulid()
    // set ulid
    setBulkULID(tempBulkULID)

    if (Object.keys(validation(bulkMessageData))?.length <= 0) {
      const tmpData = {...bulkMessageData}
      const mmsData = {
        ...tmpData,
        ulid: tempBulkULID,
        message: tmpData?.optout
          ? tmpData?.message + ' ' + `${optOutBaseUrl}/xxxxx`
          : tmpData?.message,
        messageSecond: tmpData?.optoutSecond
          ? tmpData?.messageSecond + ' ' + `${optOutBaseUrl}/xxxxx`
          : tmpData?.messageSecond,
        media: {
          filetype: tmpData?.filetype,
          url: tmpData?.url,
          mediaType: 'image',
          fileName: tmpData?.fileName,
        },
      }

      mmsData.message = replaceMessageWith(mmsData.message, '')
      mmsData.messageSecond = replaceMessageWith(mmsData.messageSecond, '')

      if (mmsData && mmsData.scheduledAt) {
        mmsData.scheduledAt = toLocalTimezone(mmsData.scheduledAt)
      }

      if (bulkMessageData?.to?.selectedType === 'contacts') {
        delete mmsData.to
      }

      if (mmsData?.camp_type === 'mms') {
        if (mmsData.senderType === 'businessName' || mmsData.senderType === 'customNumber') {
          setMMSError(true)
          setError({...error, sender: 'Select sender  is required'})
        } else {
          if ([REGION.AU].includes(currentRegion)) {
            dispatch(BulkMessageReview(mmsData))
            .then((res: any) => {
              if (res.type && res.type === 'BulkMessageReview/rejected') {
                toast.error(res?.payload)
              } else {
                if (res?.payload?.success == false) {
                  toast.error(res?.payload?.message)
                } else {
                  setReview(true)
                }
              }
            })
            .catch((error: any) => {
              toast.error(error)
            })
          } else {
            // For other region
            if(mmsData?.senderType === 'dedicatedNumber') {
              mmsData.senderType = 'dedicated'
            }

            if (mmsData.senderType === 'businessName') {
              mmsData.senderType = 'business'
            }

            if (mmsData.senderType === 'customNumber') {
              mmsData.senderType = 'custom'
            }

            const result = await sendCalculateSummary(mmsData)
            if (result?.status === false) {
              toast.error(result?.message)
            } else {
              setReview(true)
            }
          }
        }
      } else {
        if (isDefaultRegion) {
          dispatch(BulkMessageReview(mmsData))
            .then((res: any) => {
              if (res.type && res.type === 'BulkMessageReview/rejected') {
                toast.error(res?.payload)
              } else {
                if (res?.payload?.success === false) {
                  toast.error(res?.payload?.message)
                } else {
                  setReview(true)
                }
              }
            })
            .catch((error: any) => {
              toast.error(error)
            })
        } else {
          // For other region
          if(mmsData?.senderType === 'dedicatedNumber') {
            mmsData.senderType = 'dedicated'
          }

          if (mmsData.senderType === 'businessName') {
            mmsData.senderType = 'business'
          }

          if (mmsData.senderType === 'customNumber') {
            mmsData.senderType = 'custom'
          }
          
          const result = await sendCalculateSummary(mmsData)
          if (result?.status === false) {
            toast.error(result?.message)
          } else {
            setReview(true)
          }
        }
      }
    }
  }

  const successModal = useMemo(
    () => (
      <SuccessPopup
        show={successPopupModal}
        backdrop={true}
        bulkMessageData={bulkMessageData}
        firstTimeSend={firstTimeSend}
        errorMessage={sendError}
        handleClose={() => {
          setReview(false)
          if (sendError !== '') {
            setSendError('')
            setBulkMessageData(bulkMessageData)
            dispatch(
              BulkMsgDraftData({
                ...bulkMessageData,
              })
            )
          } else {
            setBulkMessageData(bulkMessageState)
            dispatch(
              BulkMsgDraftData({
                ...bulkMessageState,
                scheduledAt: '',
              })
            )
          }

          setSuccessPopupModal(false)
          dispatch(stopLoading())
          setFirstTimeSend(false)
        }}
      />
    ),
    [successPopupModal, sendError]
  )
  const purchaseModal = useMemo(
    () => (
      <PurchasePopup
        show={purchasePopupModal}
        purchaseModelData={purchaseModelData}
        handleClose={() => {
          setPurchasePopupModal(false)
        }}
      />
    ),
    [purchasePopupModal]
  )

  const contectListPopup = useMemo(
    () => (
      <ContectListsPopup
        show={contectListModel}
        handleClose={() => {
          setContectListModel(false)
        }}
        status={'subscribed'}
      />
    ),
    [contectListModel]
  )

  const contectSegmentListPopup = useMemo(
    () => (
      <ContectSegmentListsPopup
        show={contectSegmentListModel}
        selectedData={bulkMessageData?.to}
        handleClose={() => {
          setSegmentContectListModel(false)
        }}
      />
    ),
    [contectSegmentListModel, bulkMessageData]
  )

  const sendBulkMessage = async (e: any) => {
    const minimumCredit =
      bulkMessageData?.camp_type == 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
    if (
      moment().add(5, 'minutes').isBefore(moment(bulkMessageData?.scheduledAt)) ||
      bulkMessageData?.when == 'now' ||
      moment().add(5, 'minutes').isBefore(moment(bulkMessageData?.scheduledAtSecond)) ||
      bulkMessageData?.whenSecond == 'now'
    ) {
      if (bulkMessageData?.camp_type == 'sms') {
        const iid =
          bulkMessageData?.landingPageId !== '' && bulkMessageData?.landingPageId !== undefined

        let smsDataToSend: any = {
          ulid: bulkULID,
          sender: bulkMessageData?.sender?.value,
          senderType: bulkMessageData?.senderType,
          message: bulkMessageData?.optout
            ? bulkMessageData?.message + ' ' + `${optOutBaseUrl}/xxxxx`
            : bulkMessageData?.message,
          camp_type: bulkMessageData?.camp_type,
          name: bulkMessageData.name,
          landingPage: bulkMessageData.landingPageId ? true : false,
          optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
          replyStopToOptOut: bulkMessageData?.replyStopToOptOut
            ? bulkMessageData?.replyStopToOptOut
            : false,
          abTest: bulkMessageData?.abTest,
          messageSecond: bulkMessageData?.optoutSecond
            ? bulkMessageData?.messageSecond + ' ' + `${optOutBaseUrl}/xxxxx`
            : bulkMessageData?.messageSecond,
          landingPageSecond: bulkMessageData.landingPageIdSecond ? true : false,
          optoutSecond: bulkMessageData?.optoutSecond ? bulkMessageData?.optoutSecond : false,
          replyStopToOptOutSecond: bulkMessageData?.replyStopToOptOutSecond
            ? bulkMessageData?.replyStopToOptOutSecond
            : false,
        }

        if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
          smsDataToSend.contacts = bulkMessageData?.contacts
        } else {
          smsDataToSend.to = JSON.stringify(bulkMessageData.to)
        }
        if (bulkMessageData?.staggerMessages === true) {
          smsDataToSend.staggerMessages = bulkMessageData?.staggerMessages
          smsDataToSend.interval = bulkMessageData?.interval
          smsDataToSend.quantity = bulkMessageData?.quantity
        }
        if (bulkMessageData?.longUrl !== '') {
          smsDataToSend.longUrl = bulkMessageData?.longUrl
        }
        if (bulkMessageData?.longUrlSecond !== '') {
          smsDataToSend.longUrlSecond = bulkMessageData?.longUrlSecond
        }
        if (bulkMessageData?.optoutId !== '') {
          smsDataToSend.optoutId = bulkMessageData?.optoutId
        }
        if (bulkMessageData?.optoutIdSecond !== '') {
          smsDataToSend.optoutIdSecond = bulkMessageData?.optoutIdSecond
        }
        if (bulkMessageData?.when !== 'now') {
          smsDataToSend.scheduleAt = bulkMessageData?.scheduledAt
        }

        if (bulkMessageData?.whenSecond !== 'now') {
          smsDataToSend.scheduleAtSecond = bulkMessageData?.scheduledAtSecond
        }

        if (bulkMessageData.landingPageId !== '') {
          smsDataToSend.landingPageId = bulkMessageData.landingPageId
        }
        if (bulkMessageData.landingPageIdSecond !== '') {
          smsDataToSend.landingPageIdSecond = bulkMessageData.landingPageIdSecond
        }

        if (bulkMessageData.forwardReplyTo !== '') {
          smsDataToSend.forwardReplyTo = bulkMessageData.forwardReplyTo
        }

        if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT)) {
          smsDataToSend = {
            ...smsDataToSend,
            optout: false,
            replyStopToOptOut: false,
            optoutSecond: false,
            replyStopToOptOutSecond: false,
          }
        }

        if (smsDataToSend && smsDataToSend.scheduleAt) {
          smsDataToSend.scheduleAt = toLocalTimezone(smsDataToSend.scheduleAt)
        }

        if (smsDataToSend && smsDataToSend.scheduleAtSecond) {
          smsDataToSend.scheduleAtSecond = toLocalTimezone(smsDataToSend.scheduleAtSecond)
        }

        smsDataToSend.message = replaceMessageWith(smsDataToSend.message, '')
        smsDataToSend.messageSecond = replaceMessageWith(smsDataToSend.messageSecond, '')

        if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          setPurchaseModelData({
            type: bulkMessageData?.camp_type,
            purchaseCredit:
              ReviewData?.draftDeductibleCredits > minimumCredit
                ? ReviewData?.draftDeductibleCredits
                : minimumCredit,
            minimum: ReviewData?.draftDeductibleCredits,
          })
          setPurchasePopupModal(true)
        } else {
          if ([REGION.US, REGION.UK].includes(currentRegion)) {

            if(smsDataToSend?.senderType === 'dedicatedNumber') {
              smsDataToSend.senderType = 'dedicated'
            }
  
            if (smsDataToSend.senderType === 'businessName') {
              smsDataToSend.senderType = 'business'
            }
  
            if (smsDataToSend.senderType === 'customNumber') {
              smsDataToSend.senderType = 'custom'
            }

            const result = await sendFinalMessage(smsDataToSend)
            if (result?.is_error === true) {
              setSendError(result?.message)
              dispatch(stopLoadingSend())
            } else {
              dispatch(
                storeReportId({
                  id: result?.data?.bulkId,
                  camp_type: result?.data?.queueResponse?.message_type,
                  data: result?.data?.queueResponse
                })
              )
              dispatch(stopLoadingSend())
              setSuccessPopupModal(true)
            }

            setReview(false)
            return
          }
          dispatch(sendBulkMessageData(smsDataToSend))
            .then((res: any) => {
              if (sendBulkMessageData.fulfilled.match(res)) {
                if (res?.payload?.error) {
                  let errorMessage = ''
                  if (res?.payload?.error.message) {
                    errorMessage = res?.payload?.error.message
                  }

                  if (res?.payload?.message) {
                    errorMessage = res?.payload?.message
                  }
                  setSendError(errorMessage)
                } else if (
                  res?.payload?.success &&
                  res?.payload?.messsage?.includes('waiting for admin approval')
                ) {
                  setFirstTimeSend(true)
                }
                dispatch(
                  storeReportId({
                    id: res?.payload?.bulkId,
                    camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                  })
                )
                setReview(false)
                setSuccessPopupModal(true)
                if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
              } else {
                let errorMessage = 'something wrong when send data to server'
                if (res?.payload) {
                  errorMessage = res?.payload
                }
                setSendError(errorMessage)
                setSuccessPopupModal(true)
              }
              dispatch(stopLoadingSend())
            })
            .catch((error: any) => {
              setSendError(error)
              setSuccessPopupModal(true)
            })
        }
      } else {
        if (bulkMessageData.gif !== '' && bulkMessageData.gif !== undefined) {
          let mmsGifData: any = {
            ulid: bulkULID,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,
            message: bulkMessageData?.optout
              ? replaceMessageWith(bulkMessageData?.message, '') +
                ' ' +
                `${optOutBaseUrl}/xxxxx`
              : replaceMessageWith(bulkMessageData?.message, ''),
            camp_type: bulkMessageData?.camp_type,
            gif: bulkMessageData?.gif,
            subject: bulkMessageData.subject,
            name: bulkMessageData.name,
            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
            abTest: bulkMessageData?.abTest,
            messageSecond: bulkMessageData?.optoutSecond
              ? replaceMessageWith(bulkMessageData?.messageSecond, '') +
                ' ' +
                `${optOutBaseUrl}/xxxxx`
              : replaceMessageWith(bulkMessageData?.messageSecond, ''),
            landingPageSecond: bulkMessageData.landingPageIdSecond ? true : false,
            optoutSecond: bulkMessageData?.optoutSecond ? bulkMessageData?.optoutSecond : false,
            replyStopToOptOutSecond: bulkMessageData?.replyStopToOptOutSecond
              ? bulkMessageData?.replyStopToOptOutSecond
              : false,
          }
          if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
            mmsGifData.contacts = JSON.stringify(bulkMessageData?.contacts)
          } else {
            mmsGifData.to = JSON.stringify(bulkMessageData.to)
          }
          if (bulkMessageData?.staggerMessages === true) {
            mmsGifData.staggerMessages = bulkMessageData?.staggerMessages
            mmsGifData.interval = bulkMessageData?.interval
            mmsGifData.quantity = bulkMessageData?.quantity
          }
          if (
            bulkMessageData?.longUrl !== '' &&
            bulkMessageData?.longUrl !== undefined &&
            bulkMessageData?.longUrl?.length > 0
          ) {
            mmsGifData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }

          if (
            bulkMessageData?.longUrlSecond !== '' &&
            bulkMessageData?.longUrlSecond !== undefined &&
            bulkMessageData?.longUrlSecond?.length > 0
          ) {
            mmsGifData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }

          if (bulkMessageData?.optoutId !== '' && bulkMessageData?.optoutId !== undefined) {
            mmsGifData.optoutId = bulkMessageData?.optoutId
          }
          if (
            bulkMessageData?.optoutIdSecond !== '' &&
            bulkMessageData?.optoutIdSecond !== undefined
          ) {
            mmsGifData.optoutIdSecond = bulkMessageData?.optoutIdSecond
          }
          if (bulkMessageData?.when !== 'now') {
            mmsGifData.scheduleAt = bulkMessageData?.scheduledAt
          }
          if (bulkMessageData?.whenSecond !== 'now') {
            mmsGifData.scheduleAtSecond = bulkMessageData?.scheduledAtSecond
          }
          if (bulkMessageData.landingPageId !== '' && bulkMessageData.landingPageId !== undefined) {
            mmsGifData.landingPageId = bulkMessageData.landingPageId
          }
          if (
            bulkMessageData.landingPageIdSecond !== '' &&
            bulkMessageData.landingPageIdSecond !== undefined
          ) {
            mmsGifData.landingPageIdSecond = bulkMessageData.landingPageIdSecond
          }

          if (bulkMessageData.forwardReplyTo !== '') {
            mmsGifData.forwardReplyTo = bulkMessageData.forwardReplyTo
          }

          // set optout false and replyStopToOptOut false when global settings bulk mms is false
          if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT)) {
            mmsGifData = {
              ...mmsGifData,
              optout: false,
              replyStopToOptOut: false,
              optoutSecond: false,
              replyStopToOptOutSecond: false,
            }
          }

          if (mmsGifData && mmsGifData.scheduleAt) {
            mmsGifData.scheduleAt = toLocalTimezone(mmsGifData.scheduleAt)
          }

          if (mmsGifData && mmsGifData.scheduleAtSecond) {
            mmsGifData.scheduleAtSecond = toLocalTimezone(mmsGifData.scheduleAtSecond)
          }

          mmsGifData.message = replaceMessageWith(mmsGifData.message, '')
          mmsGifData.messageSecond = replaceMessageWith(mmsGifData.messageSecond, '')

          setReview(true)
          let formData = new FormData()
          for (var key in mmsGifData) {
            formData.append(key, mmsGifData[key])
          }

          if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
            setPurchaseModelData({
              type: bulkMessageData?.camp_type,
              purchaseCredit:
                ReviewData?.draftDeductibleCredits > minimumCredit
                  ? ReviewData?.draftDeductibleCredits
                  : minimumCredit,
              minimum: ReviewData?.draftDeductibleCredits,
            })
            setPurchasePopupModal(true)
          } else {

            // For other region au.
            if ([REGION.US, REGION.UK].includes(currentRegion)) {

              if(mmsGifData?.senderType === 'dedicatedNumber') {
                mmsGifData.senderType = 'dedicated'
              }
    
              if (mmsGifData.senderType === 'businessName') {
                mmsGifData.senderType = 'business'
              }
    
              if (mmsGifData.senderType === 'customNumber') {
                mmsGifData.senderType = 'custom'
              }

              if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
                mmsGifData.contacts = bulkMessageData?.contacts
              } else {
                mmsGifData.to = bulkMessageData.to
              }

              if (
                bulkMessageData?.longUrl !== '' &&
                bulkMessageData?.longUrl !== undefined &&
                bulkMessageData?.longUrl?.length > 0
              ) {
                mmsGifData.longUrl = bulkMessageData?.longUrl
              }
    
              if (
                bulkMessageData?.longUrlSecond !== '' &&
                bulkMessageData?.longUrlSecond !== undefined &&
                bulkMessageData?.longUrlSecond?.length > 0
              ) {
                mmsGifData.longUrlSecond = bulkMessageData?.longUrlSecond
              }
  
              const result = await sendFinalMessage(mmsGifData, 'send_message_mms')
              if (result?.is_error === true) {
                setSendError(result?.message)
                dispatch(stopLoadingSend())
              } else {
                dispatch(
                  storeReportId({
                    id: result?.data?.bulkId,
                    camp_type: result?.data?.queueResponse?.message_type,
                    data: result?.data?.queueResponse
                  })
                )
                dispatch(stopLoadingSend())
                setSuccessPopupModal(true)
              }
  
              setReview(false)

              return;
            };
            dispatch(sendBulkMessagemmsData(formData))
              .then((res: any) => {
                if (sendBulkMessagemmsData.fulfilled.match(res)) {
                  if (
                    res?.payload?.message != 'You are not allowed or Invalid sender to send sms'
                  ) {
                    if (res?.payload?.error) {
                      if (res?.payload?.error.message) {
                        setSendError(res?.payload?.error.message)
                      } else if (res?.payload?.message) {
                        setSendError(res?.payload?.message)
                      }
                    } else if (
                      res?.payload?.success &&
                      res?.payload?.messsage?.includes('waiting for admin approval')
                    ) {
                      setFirstTimeSend(true)
                    }
                    dispatch(
                      storeReportId({
                        id: res?.payload?.bulkId,
                        camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                      })
                    )
                    setReview(false)
                    setSuccessPopupModal(true)
                    if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
                  }
                } else {
                  let errorMessage = 'something wrong when send data to server'
                  if (res?.payload) {
                    errorMessage = res?.payload
                  }
                  setSendError(errorMessage)
                  setSuccessPopupModal(true)
                }
                dispatch(stopLoadingSend())
              })
              .catch((error: any) => {
                setSendError(error)
                setSuccessPopupModal(true)
              })
          }
        } else {
          let mediaData = bulkMessageData?.media ?? ''
          if (typeof mediaData == 'string') {
            if (mediaData?.startsWith('data:')) {
              mediaData = base64ToFile(mediaData)
            }
          }

          let mediaDataCondition: any =
            typeof mediaData == 'string' && mediaData !== ''
              ? JSON.stringify(bulkMessageData.urlData)
              : mediaData

          let mmsData: any = {
            ulid: bulkULID,
            sender: bulkMessageData?.sender?.value,
            message: bulkMessageData?.optout
              ? replaceMessageWith(bulkMessageData?.message, '') +
                ' ' +
                `${optOutBaseUrl}/xxxxx`
              : replaceMessageWith(bulkMessageData?.message, ''),
            senderType: bulkMessageData?.senderType,
            camp_type: bulkMessageData?.camp_type,
            media: mediaDataCondition,
            name: bulkMessageData.name,
            subject: bulkMessageData.subject,
            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }
          if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
            mmsData.contacts = JSON.stringify(bulkMessageData?.contacts)
          } else {
            mmsData.to = JSON.stringify(bulkMessageData.to)
          }
          if (bulkMessageData?.staggerMessages === true) {
            mmsData.staggerMessages = bulkMessageData?.staggerMessages
            mmsData.interval = bulkMessageData?.interval
            mmsData.quantity = bulkMessageData?.quantity
          }
          if (bulkMessageData?.longUrl?.length > 0 && bulkMessageData?.longUrl !== undefined) {
            mmsData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }

          if (
            bulkMessageData?.longUrlSecond?.length > 0 &&
            bulkMessageData?.longUrlSecond !== undefined
          ) {
            mmsData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }

          if (bulkMessageData?.optoutId !== '' && bulkMessageData?.optoutId !== undefined) {
            mmsData.optoutId = bulkMessageData?.optoutId
          }
          if (
            bulkMessageData?.optoutIdSecond !== '' &&
            bulkMessageData?.optoutIdSecond !== undefined
          ) {
            mmsData.optoutIdSecond = bulkMessageData?.optoutIdSecond
          }
          if (bulkMessageData?.when !== 'now') {
            mmsData.scheduleAt = bulkMessageData?.scheduledAt
          }
          if (bulkMessageData?.whenSecond !== 'now') {
            mmsData.scheduleAtSecond = bulkMessageData?.scheduleAtSecond
          }
          if (bulkMessageData.landingPageId !== '' && bulkMessageData.landingPageId !== undefined) {
            mmsData.landingPageId = bulkMessageData.landingPageId
          }
          if (
            bulkMessageData.landingPageIdSecond !== '' &&
            bulkMessageData.landingPageIdSecond !== undefined
          ) {
            mmsData.landingPageIdSecond = bulkMessageData.landingPageIdSecond
          }

          // set optout false and replyStopToOptOut false when global settings bulk mms is false
          if (!globalSettings.includes(GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT)) {
            mmsData = {
              ...mmsData,
              optout: false,
              replyStopToOptOut: false,
              optoutSecond: false,
              replyStopToOptOutSecond: false,
            }
          }

          if (mmsData && mmsData.scheduleAt) {
            mmsData.scheduleAt = toLocalTimezone(mmsData.scheduleAt)
          }

          if (mmsData && mmsData.scheduleAtSecond) {
            mmsData.scheduleAtSecond = toLocalTimezone(mmsData.scheduleAtSecond)
          }

          setReview(true)

          let formData = new FormData()
          for (var key in mmsData) {
            formData.append(key, mmsData[key])
          }

          if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
            setPurchaseModelData({
              type: bulkMessageData?.camp_type,
              purchaseCredit:
                ReviewData?.draftDeductibleCredits > minimumCredit
                  ? ReviewData?.draftDeductibleCredits
                  : minimumCredit,
              minimum: ReviewData?.draftDeductibleCredits,
            })
            setPurchasePopupModal(true)
          } else {
            // For other region au.
            if ([REGION.US, REGION.UK].includes(currentRegion)) {

              if(mmsData?.senderType === 'dedicatedNumber') {
                mmsData.senderType = 'dedicated'
              }
    
              if (mmsData.senderType === 'businessName') {
                mmsData.senderType = 'business'
              }
    
              if (mmsData.senderType === 'customNumber') {
                mmsData.senderType = 'custom'
              }
  
              if (bulkMessageData?.media) {
                mmsData.media = await fileToBase64(bulkMessageData?.media)
              };

              if (bulkMessageData?.contacts?.length > 0 && bulkMessageData?.contacts !== undefined) {
                mmsData.contacts = bulkMessageData?.contacts
              } else {
                mmsData.to = bulkMessageData.to
              }

              if (bulkMessageData?.longUrl?.length > 0 && bulkMessageData?.longUrl !== undefined) {
                mmsData.longUrl = bulkMessageData?.longUrl
              }

              const result = await sendFinalMessage(mmsData, 'send_message_mms')
              if (result?.is_error === true) {
                setSendError(result?.message)
                dispatch(stopLoadingSend())
              } else {
                dispatch(
                  storeReportId({
                    id: result?.data?.bulkId,
                    camp_type: result?.data?.queueResponse?.message_type,
                    data: result?.data?.queueResponse
                  })
                )
                dispatch(stopLoadingSend())
                setSuccessPopupModal(true)
              }
  
              setReview(false)

              return;
            };
            dispatch(sendBulkMessagemmsData(formData))
              .then((res: any) => {
                if (sendBulkMessagemmsData.fulfilled.match(res)) {
                  if (
                    res?.payload?.message != 'You are not allowed or Invalid sender to send sms'
                  ) {
                    if (res?.payload?.error) {
                      if (res?.payload?.error.message) {
                        setSendError(res?.payload?.error.message)
                      } else if (res?.payload?.message) {
                        setSendError(res?.payload?.message)
                      }
                    } else if (
                      res?.payload?.success &&
                      res?.payload?.messsage?.includes('waiting for admin approval')
                    ) {
                      setFirstTimeSend(true)
                    }
                    dispatch(
                      storeReportId({
                        id: res?.payload?.bulkId,
                        camp_type: res?.payload?.queueResponse?.addedBulk?.camp_type,
                      })
                    )
                    setReview(false)
                    setSuccessPopupModal(true)
                    if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
                    dispatch(stopLoadingSend())
                  }
                } else {
                  let errorMessage = 'something wrong when send data to server'
                  if (res?.payload) {
                    errorMessage = res?.payload
                  }
                  setSendError(errorMessage)
                  setSuccessPopupModal(true)
                }
                dispatch(stopLoadingSend())
              })
              .catch((error: any) => {
                setSendError(error)
                setSuccessPopupModal(true)
              })
          }
        }
      }
    } else {
      setShowAlert(true)
      setAlertMessage('Your selected scheduler time has already past, please select future time ')
    }
  }

  const validation = (value: any) => {
    const err: any = {}

    if (value.name === '' || value.name === undefined) {
      err.name = 'Name is required'
    }

    if (value.camp_type === '' || value.camp_type === undefined) {
      err.message = 'Message is required'
    }

    if (value.camp_type === 'mms' && value.media == '' && value.gif == '') {
      err.message = 'Message Media is required'
    }

    if (value.message === '' || value.message === undefined) {
      err.message = 'Message is required'
    }

    if (value?.contacts?.length < 0 || value?.contacts == undefined) {
      if (value.to.selectedType === '' || value.to.selectedType === undefined) {
        err.to = 'Select To  is required'
      }
      if (value.to.value === '' || value.to.value === undefined) {
        err.to = 'Select To  is required'
      }
    }
    if (value.sender?.value === '' || value.sender?.value === undefined) {
      err.sender = 'Select sender  is required'
    }
    if (value.when === '' || value.when === undefined) {
      err.when = 'Select when  is required'
    }
    if (value.staggerMessages == true) {
      if (value.interval === '' || value.interval === undefined) {
        err.when = 'Select interval  is required'
      }
      if (value.quantity === '' || value.quantity === undefined) {
        err.when = 'Select quantity  is required'
      }
    }

    const shortUrl = isDefaultRegion ? ENV().REACT_APP_SHORTURL : ENV().REACT_APP_SHORTURL_INTERNATIONAL
    const landingPageUrl = `${shortUrl}/Lxxxxx`

    if (value?.message?.includes(shortUrl) && !value?.message?.includes(landingPageUrl)) {
      const text = value?.message

      const regex = new RegExp(`${shortUrl?.replace(/\./g, "\\.")}\\/([a-zA-Z0-9_-]+)`,"gmi");
      const matches = [...text.matchAll(regex)].map(match => match.at(1)); 

      const allExist = matches.every(short => value.longUrl.some((it: any) => it.shortUrl === short));

      if (!allExist) {
        err.message = "Message contains tracking link but doesn't have short url been created"
      }
    }

    setError(err)
    return err
  }

  const sendTestMessage = (e: any) => {
    e.preventDefault()
    setSendFlag(true)
    setTimeout(() => setSendFlag(false), 3000)

    const minimumCredit =
      bulkMessageData?.camp_type == 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
    if (bulkMessageData?.message !== '' && testNumber !== '') {
      if (bulkMessageData?.camp_type == 'sms') {
        const iid =
          bulkMessageData?.landingPageId !== '' && bulkMessageData?.landingPageId !== undefined

        let smsDataToSend: any = {
          contacts: [testNumber],
          countryCode: '61',
          message: bulkMessageData?.message,
          sender: bulkMessageData?.sender?.value,
          senderType: bulkMessageData?.senderType,
          landingPage: bulkMessageData.landingPageId ? true : false,
          optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
          replyStopToOptOut: bulkMessageData?.replyStopToOptOut
            ? bulkMessageData?.replyStopToOptOut
            : false,
        }
        if (bulkMessageData?.sender?.value == '') {
          smsDataToSend.sender = '#SharedNum#'
        }

        if (bulkMessageData?.longUrl !== '') {
          smsDataToSend.longUrl = bulkMessageData?.longUrl
        }
        if (bulkMessageData?.optoutId !== '') {
          smsDataToSend.optoutId = bulkMessageData?.optoutId
        }

        if (bulkMessageData.landingPageId !== '') {
          smsDataToSend.landingPageId = bulkMessageData.landingPageId
        }

        // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
        //   setPurchaseModelData({
        //     type: bulkMessageData?.camp_type,
        //     purchaseCredit:
        //       ReviewData?.draftDeductibleCredits > minimumCredit
        //         ? ReviewData?.draftDeductibleCredits
        //         : minimumCredit,
        //     minimum: ReviewData?.draftDeductibleCredits,
        //   })
        //   setPurchasePopupModal(true)
        // } else {
          dispatch(fetchAsyncQuickSms(smsDataToSend))
        // }
      } else {
        if (bulkMessageData.gif !== '' && bulkMessageData.gif !== undefined) {
          let mmsGifData: any = {
            contacts: JSON.stringify([testNumber]),
            message: replaceMessageWith(bulkMessageData?.message, ''),
            media: '',
            gif: bulkMessageData?.gif,
            subject: bulkMessageData?.subject,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,

            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }
          if (bulkMessageData?.sender?.value == '') {
            mmsGifData.sender = '#SharedNum#'
          }

          if (bulkMessageData?.longUrl !== '') {
            mmsGifData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }
          if (bulkMessageData?.longUrlSecond !== '') {
            mmsGifData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }
          if (bulkMessageData?.optoutId !== '') {
            mmsGifData.optoutId = bulkMessageData?.optoutId
          }
          if (bulkMessageData.landingPageId !== '') {
            mmsGifData.landingPageId = bulkMessageData.landingPageId
          }

          let formData = new FormData()
          for (var key in mmsGifData) {
            formData.append(key, mmsGifData[key])
          }
          // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          //   setPurchaseModelData({
          //     type: bulkMessageData?.camp_type,
          //     purchaseCredit:
          //       ReviewData?.draftDeductibleCredits > minimumCredit
          //         ? ReviewData?.draftDeductibleCredits
          //         : minimumCredit,
          //     minimum: ReviewData?.draftDeductibleCredits,
          //   })
          //   setPurchasePopupModal(true)
          // } else {
            dispatch(fetchAsyncQuickMms(formData))
          // }
        } else {
          const isFile = typeof bulkMessageData.media === 'object'
          const isImage = isBase64Image(bulkMessageData?.media)

          const media = isImage
            ? base64ToFile(bulkMessageData?.media)
            : isFile
            ? bulkMessageData.media
            : JSON.stringify({
                filetype: bulkMessageData?.urlData?.filetype || bulkMessageData?.mediaType,
                url: bulkMessageData?.urlData?.url || bulkMessageData?.media,
                mediaType: 'image',
                fileName: bulkMessageData?.urlData?.fileName || bulkMessageData?.fileName,
              })

          let mmsData: any = {
            contacts: JSON.stringify([testNumber]),
            message: replaceMessageWith(bulkMessageData?.message, ''),
            gif: '',
            media,
            sender: bulkMessageData?.sender?.value,
            senderType: bulkMessageData?.senderType,
            subject: bulkMessageData?.subject,

            // name: bulkMessageData.name,

            landingPage: bulkMessageData.landingPageId ? true : false,
            optout: bulkMessageData?.optout ? bulkMessageData?.optout : false,
            replyStopToOptOut: bulkMessageData?.replyStopToOptOut
              ? bulkMessageData?.replyStopToOptOut
              : false,
          }

          if (bulkMessageData?.longUrl !== '') {
            mmsData.longUrl = JSON.stringify(bulkMessageData?.longUrl)
          }
          if (bulkMessageData?.longUrlSecond !== '') {
            mmsData.longUrlSecond = JSON.stringify(bulkMessageData?.longUrlSecond)
          }
          if (bulkMessageData?.optoutId !== '') {
            mmsData.optoutId = bulkMessageData?.optoutId
          }

          if (bulkMessageData.landingPageId !== '') {
            mmsData.landingPageId = bulkMessageData.landingPageId
          }
          if (bulkMessageData?.sender?.value == '') {
            mmsData.sender = '#SharedNum#'
          }

          let formData = new FormData()
          for (var key in mmsData) {
            formData.append(key, mmsData[key])
          }
          // if (credits?.credits?.[bulkMessageData?.camp_type] < ReviewData?.draftDeductibleCredits) {
          //   setPurchaseModelData({
          //     type: bulkMessageData?.camp_type,
          //     purchaseCredit:
          //       ReviewData?.draftDeductibleCredits > minimumCredit
          //         ? ReviewData?.draftDeductibleCredits
          //         : minimumCredit,
          //     minimum: ReviewData?.draftDeductibleCredits,
          //   })
            // setPurchasePopupModal(true)
          // } else {
            dispatch(fetchAsyncQuickMms(formData))
          // }
        }
      }
    }
  }
  ///////////////////////////////////////USE MEMO//////////////////////////////////////

  const WarningAlert = useMemo(
    () => (
      <AlertMessageBox
        message={alertMessage}
        show={showAlert}
        handleClose={() => setShowAlert(false)}
      />
    ),
    [showAlert]
  )

  const renderOptOutText = (second = false) => {
    let message = ''

    const settingType =
      bulkMessageData.camp_type === 'sms'
        ? GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
        : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT

    if (!globalSettings?.includes(settingType)) {
      return ''
    }

    if (second) {
      if (bulkMessageData?.optoutSecond) {
        message = `STOP: ${optoutContact}/vc`
      }

      if (bulkMessageData?.replyStopToOptOutSecond) {
        message = "Reply 'STOP' to opt-out"
      }
    }

    if (bulkMessageData?.optout) {
      message = `STOP: ${optOutBaseUrl}/vc`
    }

    if (bulkMessageData?.replyStopToOptOut) {
      message = "Reply 'STOP' to opt-out"
    }

    return message
  }

  const removeOptOutOrReply = (message: string) => {
    let replacedMessage = message

    if (replacedMessage?.includes("Reply 'STOP' to opt-ou")) {
      return replaceMessageWith(replacedMessage, '')
    }

    if (replacedMessage?.includes(`STOP: ${optOutBaseUrl}/v`)) {
      return replaceMessageWith(replacedMessage, '')
    }

    return replacedMessage
  }

  const renderOptOutTextMessage = (textMessage: any, second = false) => {
    let message = ''

    const settingType =
      bulkMessageData.camp_type === 'sms'
        ? GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
        : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT

    if (!globalSettings?.includes(settingType)) {
      return ''
    }

    if (second) {
      if (bulkMessageData?.optoutSecond !== true) {
        if (bulkMessageData.replyStopToOptOutSecond) {
          message = "Reply 'STOP' to opt-out"
        }
      } else {
        if (bulkMessageData?.optoutSecond) {
          message = `STOP: ${optOutBaseUrl}/vc`
        }
      }

      if (removeOptOutOrReply(textMessage) !== '') {
        return <span>{message}</span>
      }
    }

    if (bulkMessageData?.optout !== true) {
      if (bulkMessageData.replyStopToOptOut) {
        message = "Reply 'STOP' to opt-out"
      }
    } else {
      if (bulkMessageData?.optout) {
        message = `STOP: ${optOutBaseUrl}/vc`
      }
    }
    if (removeOptOutOrReply(textMessage) !== '') {
      return <span>{message}</span>
    }
  }

  const isCompleteGroup = groupData?.data?.status === 'Completed'

  return (
    <>
      {contectListPopup}
      {contectSegmentListPopup}
      {purchaseModal}
      {successModal}
      {WarningAlert}

      <div className='new_message m-n5'>
        <div className='row align-items-start'>
          {!review ? (
            <div className='col-xl-8 mb-10'>
              <div className='accordion' id='accordionExample'>
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('name') && 'accordion-boader'
                  }`}
                >
                  <GettingStarted
                    validation={validation}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    error={error}
                    setError={setError}
                    checkStep={checkStep}
                  />
                </div>
                {/* //////////////////////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('to') && 'accordion-boader'
                  }`}
                  style={{
                    pointerEvents: isCompleteGroup ? 'auto' : 'none',
                    opacity: isCompleteGroup ? 1 : 0.5,
                  }}
                >
                  <BulkMessageSendTo
                    errordata={error}
                    setErrorData={setError}
                    setContectListModel={setContectListModel}
                    setSegmentContectListModel={setSegmentContectListModel}
                    segmentAndTags={
                      isDefaultRegion ? segmentAndTags : [{label: 'Tags', options: tagRegion}]
                    }
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    quickSms={bulkMessageData?.camp_type == 'sms'}
                    checkStep={checkStep}
                    setCheckStep={setCheckStep}
                  />
                </div>
                {/* /////////////////Bulk_Message_Send_From/////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('sender') && 'accordion-boader'
                  }`}
                >
                  <Bulk_Message_Send_From
                    error={error}
                    setError={setError}
                    setMMSError={setMMSError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                  />
                  {mmsError ? (
                    <p
                      style={{
                        margin: 0,
                        fontSize: '14px',
                        color: 'red',
                        padding: '0px 10px 10px 20px',
                      }}
                    >
                      Error: mms can not be sent with customer business name or your own number
                    </p>
                  ) : null}
                </div>
                {/* /////////////////  Message/////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('message') && 'accordion-boader'
                  }`}
                >
                  <Bulk_Message_MesssageBox
                    error={error}
                    setError={setError}
                    setMMSError={setMMSError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                  />

                  {Object.keys(error)?.includes('message') ? (
                    <p
                      style={{
                        margin: 0,
                        fontSize: '14px',
                        color: 'red',
                        padding: '0px 10px 10px 20px',
                      }}
                    >
                      {error?.message}
                    </p>
                  ) : null}
                </div>
                {/* //////////////////////////////////////////////////////// */}
                <div
                  className={`accordion-item ${
                    Object.keys(error)?.includes('when') && 'accordion-boader'
                  }`}
                >
                  <Bulk_Message_when
                    isForwardIncomingMessage={isForwardIncomingMessage}
                    setIsForwardIncomingMessage={setIsForwardIncomingMessage}
                    error={error}
                    setError={setError}
                    setBulkMessageData={setBulkMessageData}
                    bulkMessageData={bulkMessageData}
                    checkStep={checkStep}
                  />
                </div>
              </div>

              <div className='newmessage_btns'>
                <div className='credit invisible'>
                  <span>Estimated credits: {countWords(bulkMessageData?.message)}</span>
                </div>
                <div className='btn-right'>
                  {!bulkMessageData?.abTest && isDefaultRegion ? (
                    <button
                      onClick={handleSaveData}
                      className='btn gray_bg_purple'
                      data-testid='btnSaveCampaign'
                    >
                      Save Campaign
                    </button>
                  ) : null}

                  <button
                    onClick={handelSendData}
                    className='btn btn-primary'
                    data-testid='btnReview&Send'
                  >
                    Review & Send
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <ReviewBulkMessageData
                bulkMessageData={bulkMessageData}
                segmentAndTags={segmentAndTags}
                setBulkMessageData={setBulkMessageData}
                checkStep={checkStep}
                setCheckStep={setCheckStep}
                setReview={setReview}
                handleSaveData={handleSaveData}
                sendBulkMessage={sendBulkMessage}
              />
            </>
          )}

          {/* ////////////////////////////////////////MOBILE DISPLAY//////////////////////////// */}
          <div className='col-xl-4 ps-xl-12 scroll_aside'>
            <div className='newmessage_right newmessage_right_mobile'>
              <nav>
                <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                  <button
                    className='nav-link active'
                    id='nav-home-tab'
                    data-bs-toggle='tab'
                    data-bs-target='#nav-home'
                    type='button'
                    role='tab'
                    aria-controls='nav-home'
                    aria-selected='true'
                  >
                    {/* <i className='bi bi-unlock'></i> */}
                    <KTSVG path='/media/mobile/Mobile-Unlock.svg' className='svg-icon-2' />
                  </button>
                  <button
                    className='nav-link'
                    id='nav-profile-tab'
                    data-bs-toggle='tab'
                    data-bs-target='#nav-profile'
                    type='button'
                    role='tab'
                    aria-controls='nav-profile'
                    aria-selected='false'
                  >
                    {/* <i className='bi bi-lock'></i> */}
                    <KTSVG path='/media/mobile/Mobile-Lock.svg' className='svg-icon-2' />
                  </button>
                </div>
              </nav>
              <div className='tab-content' id='nav-tabContent'>
                <div
                  className='tab-pane fade show active'
                  id='nav-home'
                  role='tabpanel'
                  aria-labelledby='nav-home-tab'
                >
                  <h5 className='text-center'>{bulkMessageData?.abTest ? 'Message A' : null}</h5>
                  <div
                    className='mobile-bg-wrapper grey-bg new_mobile'
                    style={{
                      backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                    }}
                  >
                    <div className='mobile-inner'>
                      <div className='mobile-head'>
                        <strong
                          className='msg-mobile-title p-6 d-block text-center px-12'
                          data-testid='txtPreviewSenderID'
                        >
                          <KTSVG
                            className='svg-icon-8'
                            path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                          />{' '}
                          {bulkMessageData?.senderType === '#SharedNum#'
                            ? '#SharedNum#'
                            : bulkMessageData?.sender?.value || 'Sender ID'}
                        </strong>
                      </div>
                      <div className='mobile-body'>
                        <div className='message-box' data-testid='previewMessageBox'>
                          <div className='time text-center'>Today 14:45</div>
                          {bulkMessageData?.camp_type === 'mms' && (
                            <div className='message'>
                              {bulkMessageData.subject || 'Engaging subject here'}
                            </div>
                          )}

                          {bulkMessageData?.camp_type === 'mms' &&
                            bulkMessageData?.media !== '' &&
                            bulkMessageData?.media !== undefined && (
                              <>
                                {typeof bulkMessageData?.media == 'string' && (
                                  <span>
                                    {!bulkMessageData?.mediaType?.split('/')?.includes('video') &&
                                    !bulkMessageData?.mediaType?.includes('vcard') ? (
                                      <img
                                        src={bulkMessageData?.media}
                                        alt=''
                                        className='rounded-3 mb-2'
                                      />
                                    ) : (
                                      <video
                                        src={bulkMessageData?.media}
                                        width={300}
                                        height={100}
                                        controls
                                      />
                                    )}
                                  </span>
                                )}
                                {typeof bulkMessageData?.media !== 'string' &&
                                  bulkMessageData?.media?.type && (
                                    <span>
                                      {!bulkMessageData?.media?.type
                                        ?.split('/')
                                        ?.includes('video') &&
                                        !bulkMessageData?.mediaType
                                          ?.split('/')
                                          ?.includes('vcard') && (
                                          <img
                                            src={URL.createObjectURL(bulkMessageData?.media)}
                                            alt=''
                                            className='rounded-3 mb-2'
                                          />
                                        )}

                                      {bulkMessageData?.media?.type?.includes('vcard') && (
                                        <span>
                                          <VCardPreview file={bulkMessageData?.media} />
                                        </span>
                                      )}
                                    </span>
                                  )}
                              </>
                            )}
                          {bulkMessageData?.camp_type === 'mms' ? (
                            bulkMessageData?.gif !== '' && bulkMessageData?.gif !== undefined ? (
                              <span>
                                <img src={bulkMessageData?.gif} alt='' className='rounded-3 mb-2' />
                              </span>
                            ) : !bulkMessageData?.media ? (
                              <span>
                                <img
                                  src='media/gif/default_mms_gif.gif'
                                  alt=''
                                  className='rounded-3 mb-2'
                                />
                              </span>
                            ) : null
                          ) : null}
                          <div className='message'>
                            <pre className='preview'>{`${
                              removeOptOutOrReply(bulkMessageData?.message) ||
                              `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey

${renderOptOutText()}`
                            }`}</pre>
                            {renderOptOutTextMessage(bulkMessageData?.message)}
                          </div>
                        </div>
                        <div className='send-msg'>
                          <input type='text' />
                          <a
                            href='#'
                            className='send_btn'
                            style={{
                              backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                            }}
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className='tab-pane fade'
                  id='nav-profile'
                  role='tabpanel'
                  aria-labelledby='nav-profile-tab'
                >
                  <div
                    className='mobile-bg-wrapper grey-bg'
                    style={{
                      backgroundImage: `url(${toAbsoluteUrl('/media/mobile/unlock-screen.svg')})`,
                    }}
                  >
                    <div className='unlock-screen-content'>
                      <div className='notification-outer'>
                        <div className='Notification-item'>
                          <div className='user-icon'>
                            <img
                              alt='Logo'
                              src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                            />
                          </div>
                          <div className='notification-data w-100'>
                            <label htmlFor='' data-testid='txtPreviewSenderID'>
                              &#x2329;{' '}
                              {bulkMessageData?.senderType === '#SharedNum#'
                                ? '#SharedNum#'
                                : bulkMessageData?.sender?.value || 'Sender ID'}
                              &#12297;
                            </label>

                            <div className='nofication-detail-box' data-testid='notifMessageBox'>
                              <p>{bulkMessageData?.message || 'Engaging message here'}</p>
                              {bulkMessageData?.camp_type === 'mms' &&
                                bulkMessageData?.media !== '' &&
                                bulkMessageData?.media !== undefined && (
                                  <>
                                    {typeof bulkMessageData?.media == 'string' && (
                                      <span>
                                        {!bulkMessageData?.mediaType
                                          ?.split('/')
                                          ?.includes('video') ? (
                                          <img
                                            src={bulkMessageData?.media}
                                            alt='poster'
                                            className='rounded-3 mb-2'
                                            style={{
                                              width: '30px',
                                              height: '30px',
                                            }}
                                          />
                                        ) : null}
                                      </span>
                                    )}
                                    {typeof bulkMessageData?.media !== 'string' &&
                                      bulkMessageData?.media?.type && (
                                        <span>
                                          {!bulkMessageData?.media?.type
                                            ?.split('/')
                                            ?.includes('video') ? (
                                            <img
                                              src={URL.createObjectURL(bulkMessageData?.media)}
                                              alt='poster'
                                              className='rounded-3 mb-2'
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                              }}
                                            />
                                          ) : null}
                                        </span>
                                      )}
                                  </>
                                )}

                              {bulkMessageData?.camp_type === 'mms' ? (
                                bulkMessageData?.gif !== '' &&
                                bulkMessageData?.gif !== undefined ? (
                                  <span>
                                    <img
                                      src={bulkMessageData?.gif}
                                      alt='poster'
                                      className='rounded-3 mb-2'
                                      style={{
                                        width: '30px',
                                        height: '30px',
                                      }}
                                    />
                                  </span>
                                ) : !bulkMessageData?.media ? (
                                  <span>
                                    <img
                                      src='media/gif/default_mms_gif.gif'
                                      alt='poster'
                                      className='rounded-3 mb-2'
                                      style={{
                                        width: '30px',
                                        height: '30px',
                                      }}
                                    />
                                  </span>
                                ) : null
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* AB TEST Display Message */}
            {bulkMessageData?.abTest === true && bulkMessageData.camp_type === 'sms' && (
              <div className='newmessage_right newmessage_right_mobile'>
                <nav>
                  <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                    <button
                      className='nav-link active'
                      id='nav-home-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-home'
                      type='button'
                      role='tab'
                      aria-controls='nav-home'
                      aria-selected='true'
                    >
                      {/* <i className='bi bi-unlock'></i> */}
                      <KTSVG path='/media/mobile/Mobile-Unlock.svg' className='svg-icon-2' />
                    </button>
                    <button
                      className='nav-link'
                      id='nav-profile-tab'
                      data-bs-toggle='tab'
                      data-bs-target='#nav-profile'
                      type='button'
                      role='tab'
                      aria-controls='nav-profile'
                      aria-selected='false'
                    >
                      {/* <i className='bi bi-lock'></i> */}
                      <KTSVG path='/media/mobile/Mobile-Lock.svg' className='svg-icon-2' />
                    </button>
                  </div>
                </nav>
                <div className='tab-content' id='nav-tabContent'>
                  <div
                    className='tab-pane fade show active'
                    id='nav-home'
                    role='tabpanel'
                    aria-labelledby='nav-home-tab'
                  >
                    <h5 className='text-center'>Message B</h5>
                    <div
                      className='mobile-bg-wrapper grey-bg new_mobile'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                      }}
                    >
                      <div className='mobile-inner'>
                        <div className='mobile-head'>
                          <strong
                            className='msg-mobile-title p-6 d-block text-center px-12'
                            data-testid='txtPreviewSenderID'
                          >
                            <KTSVG
                              className='svg-icon-8'
                              path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                            />{' '}
                            {bulkMessageData?.senderType === '#SharedNum#'
                              ? '#SharedNum#'
                              : bulkMessageData?.sender?.value || 'Sender ID'}
                          </strong>
                        </div>
                        <div className='mobile-body'>
                          <div className='message-box'>
                            <div className='time text-center'>Today 14:45</div>

                            <div className='message'>
                              <pre className='preview'>{`${
                                removeOptOutOrReply(bulkMessageData?.messageSecond) ||
                                `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey

${renderOptOutText(true)}`
                              }`}</pre>
                              {renderOptOutTextMessage(bulkMessageData?.messageSecond, true)}
                            </div>
                          </div>
                          <div className='send-msg'>
                            <input type='text' />
                            <a
                              href='#'
                              className='send_btn'
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                              }}
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='tab-pane fade'
                    id='nav-profile'
                    role='tabpanel'
                    aria-labelledby='nav-profile-tab'
                  >
                    <div
                      className='mobile-bg-wrapper grey-bg'
                      style={{
                        backgroundImage: `url(${toAbsoluteUrl('/media/mobile/unlock-screen.svg')})`,
                      }}
                    >
                      <div className='unlock-screen-content'>
                        <div className='notification-outer'>
                          <div className='Notification-item'>
                            <div className='user-icon'>
                              <img
                                alt='Logo'
                                src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                              />
                            </div>
                            <div className='notification-data w-100'>
                              <label htmlFor='' data-testid='txtPreviewSenderID'>
                                &#x2329;{' '}
                                {bulkMessageData?.senderType === '#SharedNum#'
                                  ? '#SharedNum#'
                                  : bulkMessageData?.sender?.value || 'Sender ID'}
                                &#12297;
                              </label>

                              <div className='nofication-detail-box' data-testid='notifMessageBox'>
                                <p>{bulkMessageData?.messageSecond || 'Engaging message here'}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* ///////////////////////////////////////////TEST YOUR MESSAGE////////////////////////// */}

            {isDefaultRegion && (
              <div className='newmessage_right'>
                <div className='msg_form'>
                  <div className='form-group w-100'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          Smart links and opt out links will not work when sending testing message
                        </Tooltip>
                      }
                    >
                      <label className='mb-2'>
                        Test your message{' '}
                        <i
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title='A/B Testing'
                          className='bi bi-question-circle-fill px-3 '
                        ></i>
                      </label>
                    </OverlayTrigger>
                    <input
                      onChange={(e: any) => setTestNumber(e.target.value)}
                      type='text'
                      data-testid='inputNumberTestMessage'
                      className='form-control form-control-lg form-control-solid px-5'
                      placeholder='mobile number'
                    />
                  </div>
                  <button
                    // disabled={bulkMessageData?.message !== '' || testNumber !== ''}
                    onClick={sendTestMessage}
                    className='btn btn-primary  ms-2 px-4'
                    data-testid='btnSendTestMessage'
                  >
                    {/* <i className='bi bi-send-fill'></i> */}
                    {sendFlag ? (
                      <KTSVG
                        path='/media/icons/duotune/general/gen037.svg'
                        className='svg-icon-2x svg-icon-danger m-0'
                      />
                    ) : (
                      <KTSVG
                        path='/media/icons/duotune/general/send.svg'
                        className='svg-icon-2x svg-icon-danger m-0'
                      />
                    )}
                  </button>
                </div>
                <small className='form-text text-muted mt-2 d-block'>
                  NOTE: This will use your credits to send and all links will be generated
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export {NewMessageStepper}
